import { STATUS_SUCCESS, STATUS_ERROR, STATUS_LOADING } from 'store/status';

import { RESET_DRAFT } from 'modules/editor/store/constants';
import { reset as initialState } from 'modules/editor/store/reducers/initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${RESET_DRAFT}_REQUESTED`: {
      return {
        ...state,
        status: STATUS_LOADING,
      };
    }

    case `${RESET_DRAFT}_FAILED`: {
      return {
        ...state,
        status: STATUS_ERROR,
      };
    }

    case `${RESET_DRAFT}_SUCCEEDED`: {
      return {
        ...state,
        status: STATUS_SUCCESS,
      };
    }

    default:
      return state;
  }
};

export default reducer;
